<template>
  <v-dialog v-model="dataValue" width="30%">
    <v-card>
      <v-card-title class="text-h5">
        <v-col>
          <p class="fontGrey--text font-weight-bold" v-if="!confirmMessage">
            מספר
            <span>
              {{ selectedDid }}
            </span>
          </p>
          <p class="secondary--text font-weight-medium">
            {{ message }}
          </p>
          <p class="fontGrey--text font-weight-bold" v-if="confirmMessage">
            {{ selectedDid }} ?
          </p>
        </v-col>
      </v-card-title>
      <v-card-actions v-if="confirmMessage">
        <v-btn
          plain
          text
          color="success"
          x-large
          class="text-h6 font-weight-bold"
          @click="$emit('createNewDID')"
          >המשך</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn
          color="fontGrey"
          text
          x-large
          class="text-h6 font-weight-bold"
          @click="dataValue = false"
        >
          חזור
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import boolMixin from "@/mixins/boolMixin.js";

export default {
  name: "DidAddPopup",
  mixins: [boolMixin],
  props: {
    message: {
      type: String,
      required: true,
      default: "",
    },
    confirmMessage: {
      type: Boolean,
      required: false,
      default: false,
    },
    selectedDid: {
      type: String,
      required: true,
      default: "",
    },
  },
};
</script>
